module.exports = __webpack_public_path__ + "assets/img/icon02.e13461d2.png";